<template>
<svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 2L6 16L2 16C0.895999 16 -5.73712e-07 16.875 -5.24537e-07 18C-4.95862e-07 18.656 0.171999 19.063 1.16 20L10 28.875C10.656 29.5 11.109 30 12 30C12.891 30 13.344 29.5 14 28.875L22.84 20C23.828 19.062 24 18.656 24 18C24 16.875 23.104 16 22 16L18 16L18 2C18 0.895 17.105 -7.47683e-07 16 -6.99382e-07L8 -3.49691e-07C6.895 -3.0139e-07 6 0.895 6 2Z" fill="white"/>
</svg>
</template>
